import { BreakpointLabel } from '../typescript-types'

export const ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT || 'DEVELOPMENT'
export const DEVELOPMENT = ENVIRONMENT === 'DEVELOPMENT'

export const API_BASE_URL = DEVELOPMENT ? `http://localhost:5001` : 'https://api.mitbestellt.de'
console.log({
	ENVIRONMENT,
	DEVELOPMENT,
	API_BASE_URL,
})

export const API_BASE_URL_GQL = `${API_BASE_URL}/graphql`
export const LANDING_URL = 'https://www.mitbestellt.de'
// Rechtstexte kommen aus der API (legalRoutes), damit App, Landing und Dashboard dieselbe Fassung
// zeigen — in Produktion also api.mitbestellt.de/DSE bzw. /IMP.
export const DATA_PROTECTION_URL = `${API_BASE_URL}/DSE`
export const IMPRESSUM_URL = `${API_BASE_URL}/IMP`
export const COMPANY_EMAIL = 'andreas@beyer-development.com'
export const companyName = 'Mitbestellt'
export const legalName = 'Beyer Development UG (haftungsbeschränkt)'
export const COMPANY_STREET = 'Kolonnenstraße 8'
export const COMPANY_POSTAL_CODE = '10827'
export const COMPANY_CITY = 'Berlin'
// Wohin die eigene Testpostkarte aus dem Statistik-Dashboard geht; dieselbe Adresse wie in der API.
export const TEST_ADDRESS = { street: 'Ziegelstr. 52', postalCode: '14641', city: 'Nauen' }
export const COMPANY_HANDELSREGISTER = 'HRB 36746 P'
export const COMPANY_REGISTERGERICHT = '14467 Potsdam'
export const GESCHAEFTSFUEHRER = 'Dr. Andreas Beyer'
export const COMPANY_PHONE = '01629873949'

export const COMPANY_LOGO = '/mitbestellt-logo.png'
export const COMPANY_LOGO_AND_TEXT = '/mitbestellt-logo-text.png'
export const COMPANY_TEXT = '/mitbestellt-text.png'

// ----------------------------------------
// zindexes
// ----------------------------------------

// deafult z-indexes of material-ui components:
// mobile stepper: 1000
// fab: 1050
// speed dial: 1050
// app bar: 1100
// drawer: 1200
// modal: 1300
// snackbar: 1400
// tooltip: 1500

// dialog neeeds to go over app bar

export const APP_BAR_ZINDEX = 1100
export const POPPER_ZINDEX = 1103
// MUI Modal/Dialog defaults to 1300; custom dialogs must render above it
export const DIALOG_ZINDEX = 1302
export const DIALOG_BACKGROUND_ZINDEX = 1301
// Restaurant-Auswahl und Tabs kleben unter der AppBar, müssen also darunter bleiben.
export const RESTAURANT_HEADER_ZINDEX = 1098
// Feste Höhe, damit Leisten darunter (etwa in MenuView) genau unter dem Kopf andocken können.
export const RESTAURANT_HEADER_HEIGHT_REM = 4.75

// ----------------------------------------
// MAPBOX
// ----------------------------------------

export const MAPBOX_PUBLIC_TOKEN =
	'pk.eyJ1IjoiYWJleWVyMTIzIiwiYSI6ImNsb2c0dDlhNjE0MjEycXA5d3kzMDF0ZTAifQ.wNm_dX6_8_U4q11r3o5KDQ'

export const breakpoints: { label: BreakpointLabel; px: number; sizingFactor: number }[] = [
	{ label: 'xs', px: 0, sizingFactor: 0.25 },
	{ label: 'sm', px: 300, sizingFactor: 0.5 },
	{ label: 'md', px: 700, sizingFactor: 1 },
	{ label: 'lg', px: 1100, sizingFactor: 1.25 },
	{ label: 'xl', px: 1500, sizingFactor: 2 },
]

export const contentMaxWidthPx = 1440
